import React from 'react'
import Link from 'gatsby-link'

import logo from '../assets/images/logo.svg';

const Footer = (props) => (
    <footer id="footer">
        <section>
            <h2>Contact</h2>
            <dl className="alt">
                <dt>Adresa</dt>
                <dd>Strada Constantin Noica nr. 140 <br/>Bucuresti, Sector 6, 060057, Romania</dd>
                <dt>Telefon</dt>
                <dd>031 425 7298</dd>
                <dt>Email</dt>
                <dd><a href="#">scoalaikg@gmail.com</a> </dd>
            </dl>
            <ul className="icons">
                <li><a href="http://www.unefsb.ro" className="icon fa-globe  alt"><span className="label">Website</span></a></li>
                <li><a href="#" className="icon fa-facebook alt"><span className="label">Facebook</span></a></li>
            </ul>
        </section>
        <p className="copyright">&copy; IKG Modul Online <br/>Design by Imaflux Design Studio</p>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js